/** Portal tutorial video URLs - one per role. Update when role-specific videos are available. */
export const PORTAL_VIDEO_URLS = {
    CLIENT: "https://share.synthesia.io/675ed1b2-4737-4c19-853b-1b3944d8ee08",
    CONTRACTOR: "https://share.synthesia.io/675ed1b2-4737-4c19-853b-1b3944d8ee08",
    SURVEYOR: "https://share.synthesia.io/675ed1b2-4737-4c19-853b-1b3944d8ee08",
};
/** Embed URLs for portal tutorial video modal - one per role. Update when role-specific videos are available. */
export const PORTAL_VIDEO_EMBED_URLS = {
    CLIENT: "https://share.synthesia.io/embeds/videos/3c81bf79-4025-49ee-9bb7-0f95bb81ffe4",
    CONTRACTOR: "https://share.synthesia.io/embeds/videos/a2dda48e-1ad6-48a8-87d0-a20eb11cae40",
    SURVEYOR: "https://share.synthesia.io/embeds/videos/e286da38-d668-478f-b0e0-173be9e0ef84",
};
